(function () {
  "use strict";

  angular
    .module("virtualFairs")
    .controller(
      "VirtualFairAddEventDataController",
      VirtualFairAddEventDataController
    );
    VirtualFairAddEventDataController.$inject = [
    "VirtualFairService",
    "$timeout",
    '$uibModal'
  ];

  function VirtualFairAddEventDataController(
    VirtualFairService,
    $timeout,
    $uibModal
  ) {
    var vm = this;
    vm.getVirtualFairs = getVirtualFairs;
    vm.getByFilter = getByFilter;
    vm.queryFlag = false;
    vm.virtualFairSelected = "";
    vm.virtualFairsData = [];
    vm.openEditModal = openEditModal;
    vm.synchronizeAfterUpdate = synchronizeAfterUpdate;

    /* PAGINATION */
    vm.pageChanged = pageChanged;
    vm.setPage = setPage;
    vm.page = 1;

    function setPage(page) {
      vm.currentPage = page;
    }

    function pageChanged(page) {
      vm.page = vm.currentPage;
      vm.getByFilter(false);
    }

    function getVirtualFairs() {
      vm.query = {};
      vm.query = {'upcoming': 1};
      VirtualFairService.getAll(vm.query).then(function (response) {
        vm.virtualFairs = response.data;
        vm.virtualFairs.unshift({
          id: -1,
          name: '-- ALL --'
        });
        vm.virtualFairSelected = -1;
      });
    }

    function getByFilter() {
      vm.queryFlag = false;
      vm.query = {};
      vm.query["upcoming"] = 1;
      vm.query["page"] = vm.page;
      vm.query["do-paginate"] = 1;
      if (vm.virtualFairSelected) {
        vm.query["virtual_fair_id"] = vm.virtualFairSelected;
      }
      VirtualFairService.getAll(vm.query, true).then(function (response) {
        vm.queryFlag = true;
        vm.virtualFairsData = response.data.data;
        vm.to = response.data.to;
        vm.totalItems = response.data.total;
        vm.itemsPerPage = response.data.per_page;
        vm.setPage(response.data.current_page);
      });
    }

    function openEditModal(virtualFair) {
      $uibModal.open({
          templateUrl: 'templates/virtualfairs/add-event-data/edit/template.modal.html',
          controller: 'EditModalAddEventDataController',
          controllerAs:'vm',
          
          resolve:
          {
              virtualFair      : function () {
                  return virtualFair;
              },
          }
      }).result.then(function(result) {
        vm.synchronizeAfterUpdate(result);
      }).catch(function(reason) {
        console.log(reason);
        throw reason;
      });
    }

    function synchronizeAfterUpdate(updatedItem) {
      if(updatedItem) {
        vm.virtualFairsData = vm.virtualFairsData.map((virtualFair) => {
          if(virtualFair.id == updatedItem.id) {
            virtualFair.platform_fair_id = updatedItem.platform_fair_id;
            virtualFair.platform_fair_code = updatedItem.platform_fair_code;
            virtualFair.platform_prefix = updatedItem.platform_prefix;
          }
          return virtualFair;
        });
      }
    }

    function active() {
      vm.getVirtualFairs();
    }

    active();
  }
})();
